import { useLocation } from 'react-router';

import { Routes } from '@/_navigation';
import { dateTime, useGetIp } from '@/_shared';

import type { TUseGlobalData } from './use-global-data';

export function useLog({ auditLog }: { auditLog: TUseGlobalData['auditLog'] }) {
  const { pathname } = useLocation();
  const ip = useGetIp();

  const termsSignedBy = (pathname.indexOf(Routes.CHECKOUT.link as string) > -1 ? 'representative' : 'customer') as
    | 'representative'
    | 'customer';

  const getSystemData = () => ({
    ipAddress: ip as string,
    userAgent: window.navigator.userAgent,
  });

  const getCustomerData = () => {
    const nAuditLog = {
      ...auditLog,
      termsSignedBy,
      customer: getSystemData(),
      customerSubmissionDate: dateTime.now().toISOString(),
    };
    return nAuditLog;
  };
  const getRepresentativeData = () => ({
    ...auditLog,
    checkoutDate: dateTime.now().toISOString(),
    termsSignedBy: auditLog?.termsSignedBy ?? termsSignedBy,
    representative: getSystemData(),
  });

  const updateTerms = (isAgree: boolean, index: number) => {
    const termsSubSections = { ...auditLog.termsSubSections };
    termsSubSections[index] = { isSigned: isAgree, signedDate: dateTime.now().toISOString() };
    return { ...auditLog, termsSubSections };
  };

  return { getCustomerData, getRepresentativeData, updateTerms };
}
